import React, { PropTypes } from "react";

const FormattedHeightLimit = ({ size }) => {
  var bottomHeight = size.minHeight;
  if(size.minHeight === "0") {
    bottomHeight = "up";
  }
  return <span>{bottomHeight} to {size.maxHeight} inches</span>;
};

FormattedHeightLimit.propTypes = {
  size: PropTypes.object.isRequired,
};

export default FormattedHeightLimit;


/** WEBPACK FOOTER **
 ** ./src/components/AvailableSizes/CarSeatsContainer/Descriptions/FormattedHeightLimit.js
 **/